import React from 'react'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'

import Tag from 'shared-web/src/components/Tag'
import CQLBar from '../ActionConfigCQL'
import PlaybookModal from '../PlaybookModal'

import calendarSrc from '!svg-inline!images/svg/calendar-action.svg'
import commentSrc from '!svg-inline!images/svg/comment-action.svg'
import closeSrc from '!svg-inline!images/svg/close-action.svg'
import cqlSrc from '!svg-inline!images/svg/bolt-outline.svg'

import { ActionViewConfig } from 'app/modules/playbook/constants'

import style from './style.styl'

const ActionCard = ({
  children,
  isSelected,
  disabled,
  title,
  description,
  handleClick,
  iconSrc,
}) => {
  return (
    <div
      className={cx({ selected: isSelected }, { disabled: disabled }, 'goal-action-choice')}
      onClick={!disabled ? handleClick : null}
    >
      <IconSVG element="div" className="action-icon" src={iconSrc} />
      <strong>{title}</strong>
      <p>{description}</p>
      {children}
    </div>
  )
}

const ConfigureAction = ({ children, handleCancel, title, description }) => {
  return (
    <div className="goal-action-config-wrapper drift-form flex-column">
      <div className="goal-action-config-cancel" onClick={handleCancel}>
        &lt; Back to Actions
      </div>
      <div className="goal-action-config">
        <div className="goal-action-cta">{title}</div>
        <div className="goal-action-description">{description}</div>
        <div>{children}</div>
      </div>
    </div>
  )
}

const GoalActionModal = ({
  classificationDetails,

  onCloseClick,
  onCancelClick,

  handleSelectCalendar,
  handleSelectMessage,
  handleSelectAutoClose,
  handleSelectCql,

  isCalendarSelected,
  isMessageSelected,
  isAutoCloseSelected,
  isCqlSelected,

  isLeadBotPlaybook,

  disableCalendar,
  disableMessage,
  disableAutoClose,

  hasCalendarAction,
  hasAutoCloseAction,

  onResetViewClick,
  onConfigureCqlClick,
  viewMode,
}) => (
  <PlaybookModal
    title="Goal Action"
    description={_.get(classificationDetails, 'label', '...')}
    onCancelClick={onCancelClick}
    cancelLabel="Cancel"
    onCloseClick={onCloseClick}
    closeLabel="Add"
    showSaveStatus={false}
    contentClassName={style.GoalActionModalContent}
    headerClassName={style.GoalActionModalHeader}
  >
    <div className={style.GoalActionModal}>
      {viewMode === ActionViewConfig.CQL && (
        <ConfigureAction
          handleCancel={onResetViewClick}
          title="How should these leads be marked?"
          description="Mark leads as either “not qualified” or as a CQL (conversation qualified lead.) You can even indicate CQL quality by assigning more ⚡️."
        >
          <CQLBar handleSelectCql={handleSelectCql} />
        </ConfigureAction>
      )}
      {viewMode === null && (
        <div className="goal-action-wrapper drift-form flex-column">
          <div className="goal-action-cta">Select an action to add:</div>
          <div className="goal-action-card-wrapper flex">
            {isLeadBotPlaybook && hasCalendarAction && (
              <ActionCard
                isSelected={isCalendarSelected}
                disabled={disableCalendar}
                iconSrc={calendarSrc}
                handleClick={handleSelectCalendar}
                title="Send Calendar"
                description="Send the calendar of the person selected during routing at the end of the conversation to book a meeting."
              />
            )}
            {isLeadBotPlaybook &&
              <ActionCard
                isSelected={isMessageSelected}
                disabled={disableMessage}
                handleClick={handleSelectMessage}
                iconSrc={commentSrc}
                title="Send Message"
                description="Send a closing message from the bot to anyone who hits this goal."
              />
            }
            <ActionCard
              isSelected={isCqlSelected}
              handleClick={onConfigureCqlClick}
              iconSrc={cqlSrc}
              title="Mark as CQL"
              description="Qualify (or disqualify) leads by marking your best leads as CQLs (or Conversation Qualified Leads)."
            />
            {isLeadBotPlaybook &&
              <ActionCard
                isSelected={isAutoCloseSelected}
                disabled={!hasAutoCloseAction || disableAutoClose}
                handleClick={handleSelectAutoClose}
                iconSrc={closeSrc}
                title="Auto Close Conversation"
                description="Automatically close the conversation associated with this goal."
              >
                {!hasAutoCloseAction && (
                  <Tag className="enterprise-tag" tag={{ name: 'Available in Enterprise Plan' }} />
                )}
              </ActionCard>
            }
          </div>
        </div>
      )}
    </div>
  </PlaybookModal>
)

export default GoalActionModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/GoalActionModal/component.js